import { useTranslation } from 'react-i18next';
import { mockMarketSettings } from '@/mocks/dashboard';
import DashboardMarket from './components/DashboardMarket';

export default function MarketPage() {
  const { t } = useTranslation('dashboard');
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-xl md:text-2xl font-bold text-ink-700">{t('dashboard.market.title')}</h1>
        <p className="text-sm text-ink-300 mt-1">Regional and currency preferences</p>
      </div>
      <DashboardMarket settings={mockMarketSettings} />
    </div>
  );
}